// extracted by mini-css-extract-plugin
module.exports = {"EnrollmentFormTextArea":"FormTextArea_EnrollmentFormTextArea__2KKiE","error":"FormTextArea_error__35MQ3"};